import React, { ReactElement } from 'react';
import { SubmissionCommentFormState } from './state/SubmissionCommentFormState';
import { SimpleUserView } from '../../../types/users';
import { UserProfileCell } from '../../../../commonv3/components/atoms/users/UserProfileCell';
import { HTMLInput } from '../../../../commonv3/components/atoms/forms/primitive/HTMLInput';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './submissionCommentForm.module.scss';
import { observer } from 'mobx-react';
import { CheckBoxInput } from '../../atoms/forms/CheckBoxInput';
import { ISODateTime } from '../../../../admin/types/date';

type Props = {
    user: SimpleUserView;
    formState: SubmissionCommentFormState;
    bottomText?: string | ReactElement;
    loading?: boolean;
    onSubmit: () => any;
};

export const SubmissionCommentForm = observer(({ user, formState, bottomText, onSubmit, loading = false }: Props) => {
    const { content } = formState.fields;
    return (
        <div styleName="submission-comment-form" id="submission-comment-form">
            <div styleName="header">
                <UserProfileCell user={user} size="l" />
            </div>
            <div styleName="body">
                <HTMLInput
                    id="comment-content-input"
                    value={content.getDirtyValue()}
                    placeholder="コメントを入力してください"
                    error={content.hasErrors()}
                    onChange={(v) => {
                        content.setDirtyValue(v);
                    }}
                    onBlur={content.validate}
                    styleName="input"
                />
            </div>
            {bottomText && <div styleName="bottom-text">{bottomText}</div>}
            <div styleName="submit-button-wrapper">
                <Button
                    type="primary"
                    size="m"
                    onClick={onSubmit}
                    styleName="submit-button"
                    loading={loading}
                    id="submit-button"
                >
                    コメントする
                </Button>
            </div>
        </div>
    );
});

type ForLessonHomeworkReviewerProps = {
    user: SimpleUserView;
    formState: SubmissionCommentFormState;
    review_completed_at: ISODateTime | null;
    bottomText?: string | ReactElement;
    loading?: boolean;
    onSubmit: () => any;
};

export const SubmissionCommentFormForLessonHomeworkReviewer = observer(
    ({
        user,
        formState,
        review_completed_at,
        bottomText,
        onSubmit,
        loading = false,
    }: ForLessonHomeworkReviewerProps) => {
        const { content, review_complete } = formState.fields;
        return (
            <div styleName="submission-comment-form" id="submission-comment-form">
                <div styleName="header">
                    <UserProfileCell user={user} size="l" />
                </div>
                <div styleName="body">
                    <HTMLInput
                        id="comment-content-input"
                        value={content.getDirtyValue()}
                        placeholder="コメントを入力してください"
                        error={content.hasErrors()}
                        onChange={(v) => {
                            content.setDirtyValue(v);
                        }}
                        onBlur={content.validate}
                        styleName="input"
                    />
                </div>
                {bottomText && (
                    <div styleName="bottom-text" data-value="bottom-text">
                        {bottomText}
                    </div>
                )}
                {!review_completed_at && (
                    <div styleName="review-complete-checkbox">
                        <CheckBoxInput
                            label={'このコメントで添削を完了する'}
                            checked={review_complete.getDirtyValue()}
                            onCheck={(checked) => review_complete.setDirtyValue(checked)}
                            className={'review-complete-checkbox'}
                        />
                    </div>
                )}
                <div styleName="submit-button-wrapper">
                    <Button
                        type="primary"
                        size="m"
                        onClick={onSubmit}
                        styleName="submit-button"
                        loading={loading}
                        id="submit-button"
                    >
                        コメントする
                    </Button>
                </div>
            </div>
        );
    }
);
